<template>
  <PaymentsFilter @export="exportReport" />
</template>
<script>
import PaymentsFilter from './components/PaymentsFilter.vue';

import reportsApi from '../../../../services/reports.api';
import functions from '../../../../utils/functions';
import notify from '../../../../utils/notify';

export default {
  name: 'PaymentsReport',
  components: {
    PaymentsFilter,
  },
  methods: {
    async exportReport(filters) {
      try {
        this.$vs.loading();
        const buffer = await reportsApi.exportPaymentReport(filters);
        const now = functions.formataDataMomentJS(
          new Date().toISOString(),
          'DD-MM-YYYY HH:mm',
        );

        const fileName = `Relatório Pagamentos - ${now}.xlsx`;
        await functions.downloadFromBuffer(window, buffer, fileName);
      } catch (error) {
        notify.notifyFail(this.$vs, 'Falha ao gerar o relatório de pagamentos');
      } finally {
        this.$vs.loading.close();
      }
    },
  },
};
</script>
